<form [formGroup]="form" novalidate>

    <div class="row">
        <div class="col-md-6">
            <div class="form-group row">
                <label class="col-sm-3 col-form-label">Delivery Date</label>
               
                <div class="col-sm-9" >
                    <div class="row">
                        <div class="col">
                            <input type="date" formControlName="startdate" class="form-control form-control-sm" placeholder="Start Date">
                        </div>
                        <div class="col-1 p-0">
                            &nbsp; &nbsp;<span>_</span>&nbsp;&nbsp;
                        </div>
                        <div class="col">
                            <input type="date" formControlName="enddate" class="form-control form-control-sm" placeholder="End Date">
                        </div>
                    </div>
                 
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group row">
                <label class="col-sm-3 col-form-label">Total Range</label>
                <div class="col-sm-9" style="display:flex;">
                    <input type="text" formControlName="startrange" class="form-control form-control-sm" placeholder="Start Range">
                   &nbsp; &nbsp;<span>_</span>&nbsp;&nbsp;
                    <input type="text" formControlName="endrange" class="form-control form-control-sm" placeholder="End Range">
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group row">
                <label class="col-sm-3 col-form-label">Delivery NO</label>
                <div class="col-sm-9">
                    <input type="text"  formControlName="delivery_no"class="form-control form-control-sm" placeholder="Delivery NO">
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group row">
                <label class="col-sm-3 col-form-label">Customer</label>
                <div class="col-sm-9">
                    <!-- <input type="text" formControlName="customerName" class="form-control form-control-sm" placeholder="Customer  Name"> -->
                      <app-multiautocomplete [options]="customerID" [control]="CustomersFormControl" text="" id="id" formControlName="customer_id"
                objectName="user-root" param1="customer_code" param2="name" (selectionchanged)="selectionchangedCustomer()" >
              </app-multiautocomplete>
                </div>
            </div>
        </div>
      
        <div class="col-md-6">
            <div class="form-group row">
                <label class="col-sm-3 col-form-label">Salesman</label>
                <div class="col-sm-9">
                     <app-multiautocomplete isSingle="false" [options]="salesmanList" (selectionchanged)="selectionchangedSalesman()"
                                    [control]="SalesmanFormControl" text="salesman_name" id="id"
                                    placeholder="Search Salesman">
                                </app-multiautocomplete>
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group row">
              <label class="col-sm-3 col-form-label">Brachplant</label>
              <div class="col-sm-9">
                <app-multiautocomplete isSingle="false" objectName="code-root" [options]="storageLocation" (selectionchanged)="selectionchangedstorageLocation()"
                [control]="branchplantsFormControl" text="name" id="id" param1="code" param2="name">
              </app-multiautocomplete>
              </div>
            </div>
          </div>
        <!-- <div class="col-md-6">
            <div class="form-group row">
                <label class="col-sm-3 col-form-label">Status</label>
                <div class="col-sm-9">
                    <mat-select class="form-control form-control-sm" formControlName="current_stage">
                        <mat-option *ngFor="let item of statusList" [value]="item.id">
                          {{ item.name }}
                        </mat-option>
                      </mat-select>
                </div>
            </div>
        </div> -->
        <div class="col-md-6">
            <div class="form-group row">
              <label class="col-sm-3 col-form-label">Status</label>
              <div class="col-sm-9">
                <mat-select multiple class="form-control form-control-sm" formControlName="current_stage">
                  <mat-option *ngFor="let item of statusList" [value]="item.id">
                    {{ item.name }}
                  </mat-option>
                </mat-select>
              </div>
            </div>
          </div>
          <!-- <div class="col-md-6">
            <div class="form-group row">
              <label class="col-sm-3 col-form-label">Delivery Status</label>
              <div class="col-sm-9">
                <mat-select class="form-control form-control-sm" formControlName="approval_status">
                  <mat-option *ngFor="let item of orderStatusList" [value]="item.id">
                    {{ item.name }}
                  </mat-option>
                </mat-select>
              </div>
            </div>
          </div> -->
          <div class="col-md-6">
            <div class="form-group row">
              <label class="col-sm-3 col-form-label">Service Channel</label>
              <div class="col-sm-9">
                 <mat-select multiple class="form-control form-control-sm" formControlName="channel_name">
                                    <mat-option *ngFor="let item of channelList" [value]="item.id">
                                    {{ item?.name }}
                                    </mat-option>
                                </mat-select>
              </div>
            </div>
          </div>
           <div class="col-md-6">
            <div class="form-group row">
              <label class="col-sm-3 col-form-label">Item</label>
              <div class="col-sm-9">
                <app-multiautocomplete isSingle="false" [options]="filteredItems" [control]="itemsFormControl" text="" formControlName="item_id"
                  id="id" objectName="item-portfolio-root" (selectionchanged)="selectionchangedItems()" param1="item_code"
                  param2="item_name">
                </app-multiautocomplete>
              </div>
            </div>
          </div>
    </div>
</form>